import React from 'react'
import { array } from 'prop-types'

import Grid from '../../Grid'
import Card from '../../Card'
import Hide from '../../Hide'
import CardGrid3 from './CardGrid3'
import Surround from '../../Surround'
import Tag from '../../Tag'
import SimpleList from '../../SimpleList'

const CardGrid10 = ({ articles }) => {
  if (!articles.length) return null

  const formattedArticles = articles?.map((article) => ({
    id: article.id,
    content: article.title,
    href: article.link,
    eventId: article.eventId,
    eventBaseSlug: article.eventBaseSlug
  }))
  const listArticles = [9, 10, 11, 12].map((item) => formattedArticles[item])

  const imageRatio = 126 / 167
  return (
    <>
      <Hide below="desktop">
        <Grid flex gutter="default">
          <Grid.Item width={{ d: 1 / 3 }} trailingGap="mobile">
            <Grid>
              {articles.length > 8 && (
                <Grid.Item trailingGap="default">
                  <SimpleList listData={listArticles} />
                </Grid.Item>
              )}
              <Grid.Item>
                <Card
                  typeConfig={{
                    title: {
                      size: ['heading7', 'heading4'],
                      themed: true
                    }
                  }}
                  headerComponents={() => {
                    if (!articles[0].featured) return null
                    return (
                      <Tag themedFont background="white">
                        Featured
                      </Tag>
                    )
                  }}
                  inverse={articles[0].featured}
                  inset={articles[0].featured}
                  {...{
                    ...articles[0],
                    sizes: [
                      '(min-width: 1420px) 298px',
                      '(min-width: 960px) calc(25vw - 32px - 80px)',
                      'calc((100vw - 80px) * 0.5)'
                    ],
                    width: 298
                  }}
                  imageRatio={imageRatio}
                />
              </Grid.Item>
            </Grid>
          </Grid.Item>
          <Grid.Item width={{ d: 2 / 3 }} trailingGap="mobile">
            <CardGrid3 articles={articles.slice(1, 9)} />
          </Grid.Item>
        </Grid>
      </Hide>
      <Hide at="desktop">
        <Grid>
          <Grid.Item trailingGap="mobile">
            <SimpleList
              listData={[formattedArticles[9], formattedArticles[10]]}
            />
          </Grid.Item>
          <Grid.Item trailingGap="mobile">
            <Surround padded="mobile" bordered="mobile">
              <Card
                {...{
                  ...articles[1],
                  sizes: [
                    '(min-width: 1420px) 330px',
                    '(min-width: 960px) calc(25vw - 32px - 80px)',
                    'calc((100vw - 80px) * 0.5)'
                  ],
                  width: 330
                }}
                imageRatio={imageRatio}
              />
            </Surround>
          </Grid.Item>
          <Grid.Item trailingGap="mobile">
            <Card
              inverse
              inset
              {...{
                ...articles[0],
                sizes: [
                  '(min-width: 1420px) 330px',
                  '(min-width: 960px) calc(25vw - 32px - 80px)',
                  'calc((100vw - 80px) * 0.5)'
                ],
                width: 330
              }}
              imageRatio={imageRatio}
            />
          </Grid.Item>
          <Grid.Item trailingGap="mobile">
            <Surround padded="mobile" bordered="mobile">
              <Card
                horizontal
                gridGutter="default"
                {...{
                  ...articles[3],
                  sizes: [
                    '(min-width: 1420px) 141px',
                    '(min-width: 960px) calc(25vw - 32px - 80px)',
                    'calc((100vw - 80px) * 0.5)'
                  ],
                  width: 141
                }}
                imageRatio={imageRatio}
              />
            </Surround>
          </Grid.Item>
          <Grid.Item trailingGap="mobile">
            <Card
              horizontal
              gridGutter="default"
              {...{
                ...articles[4],
                sizes: [
                  '(min-width: 1420px) 141px',
                  '(min-width: 960px) calc(12.5vw - 32px - 80px)',
                  'calc(50vw - 80px)'
                ],
                width: 141
              }}
              imageRatio={imageRatio}
            />
          </Grid.Item>
        </Grid>
      </Hide>
    </>
  )
}

CardGrid10.propTypes = {
  articles: array
}

export default CardGrid10
